import { type FC } from 'react'
import { type ArrayFieldTemplateItemType } from '@rjsf/utils'
import { FormHint } from './FormHint'
import { AddItemLink } from './AddItemLink'
import { ItemRemoveButton } from './IconButtons'

interface ArrayRowsProps {
  items: ArrayFieldTemplateItemType[]
  canAdd: boolean
  locked: boolean
  noun: string
  emptyText: string
  onAddClick: () => void
}

export const ArrayRows: FC<ArrayRowsProps> = ({ items, canAdd, locked, noun, emptyText, onAddClick }) => (
  <div className='d-flex flex-column zocks-gap-0.5 pt-2'>
    {items.length === 0 && emptyText ? <FormHint>{emptyText}</FormHint> : null}
    {items.map((item) => (
      <div key={item.key} className='d-flex align-items-center zocks-gap-0.5'>
        <div className='flex-fill mw-0'>{item.children}</div>
        <ItemRemoveButton item={item} noun={noun} />
      </div>
    ))}
    {canAdd ? <AddItemLink noun={noun} disabled={locked} onClick={onAddClick} /> : null}
  </div>
)
